



































































import { Component, Mixins, Watch } from "vue-property-decorator";
import { DocumentsAsReqBody } from "@/models/app-api";
import { DocumentsByContract } from "@/models/contract";
import Page from "@/components/for-page-grid/Page.vue";
import DocumentTable from "@/components/for-documents-view/DocumentTable.vue";
import DocGetterDialog from "@/components/for-documents-view/DocGetterDialog.vue";
import XNotice from "@/components/hoc/SimpleNotice.vue";
import AppApiMixin from "@/components/mixins/AppApi.vue";
import {mapGetters, mapState} from "vuex";
import {paymentForm} from "@/assets/scripts/form-fields/main";
import HelpCard from "@/components/for-payments-view/HelpCard.vue";
import PaymentForm from "@/components/for-payments-view/PaymentForm.vue";

@Component({
  components: {
    Page,
    DocumentTable,
    DocGetterDialog,
    XNotice,
    HelpCard,
    PaymentForm
  },
  computed: {
    ...mapState({
      appEnviroment: "appEnviroment",
    }),
    ...mapGetters({
      email: "user/email",
    }),
  },
})
class Documents extends Mixins(AppApiMixin) {
  docsProps: DocumentsAsReqBody = {
    contractId: -1,
    type: -1,
    noPayment: -1,
    from: "",
    to: "",
  };
  documentList: DocumentsByContract[] = [];
  currentDocNumber = -1;

  // Состояния всплывающих элементов страницы.
  showDocSendingDialog = false;
  useDocSendingDialogNotice = false;
  targetEmail = "";

  showDocDownloadingDialog = false;

  public mounted() {
    console.log(this.docsProps);
    console.log(this.documentList);

  }


  @Watch("docsProps")
  public docsPropsChanged() {
    this.getDocumentsByContract(
        this.docsProps,
        (documentList: DocumentsByContract[]) => {
          this.documentList = documentList;
        }
    );
  }

  get amount() {
    return this.$route.params.amount || 0
  }

  get total() {
    const { appEnviroment } = this;
    return +this.amount + (+this.amount * (+appEnviroment.constants["PaymentFee"] || 0))
  }

  get userEmail() {
    return this.email
  }

  get docs() {
    return this.$route.params.docs || ''
  }

  public closeAllDialogs() {
    this.showDocSendingDialog = false;
    this.showDocDownloadingDialog = false;

    this.currentDocNumber = -1;
    this.targetEmail = "";
  }
}

export default Documents;
